export const branch = {
    "type": "FeatureCollection",
    "name": "CGC Branches",
    "crs": {
      "type": "name",
      "properties": {
        "name": "urn:ogc:def:crs:OGC:1.3:CRS84"
      }
    },
    "features": [
      {
        "type": "Feature",
        "properties": {
          "category": "cgc",
          "hours": "10am - 6pm",
          "description": "5 GF, Kompleks Perniagaan Utama Sultanah Sambungan Lebuhraya Sultanah Bahiyah, 05350 Alor Setar, Kedah",
          "name": "CGC Kedah",
          "phone": "+6047312300",
          "fax": "+6047341500",
          "ptc": "Sri Atikah Mohd Saad",
          "email": "sri@cgc.com.my",
          "storeid": "01",
          "state": "Kedah",
          "city": "Alor Setar",
          "geometry": {
            "type": "Point",
            "coordinates": [
              100.3664425,
              6.1431326
            ]
          }
        },
        "geometry": {
          "type": "Point",
          "coordinates": [
            100.3664425,
            6.1431326
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "category": "cgc",
          "hours": "10am - 6pm",
          "description": "Ground Floor, B-G-04, No. 42, Persiaran Greentown 1, Greentown Business Centre, 30450 Ipoh, Perak Darul Ridzuan",
          "name": "CGC Ipoh",
          "phone": "+6052433900",
          "fax": "+6052434900",
          "ptc": "Punitha Jeyabalan",
          "email": "punitha@cgc.com.my",
          "storeid": "02",
          "state": "Perak",
          "city": "Ipoh",
          "geometry": {
            "type": "Point",
            "coordinates": [
              101.0945067,
              4.5985263
            ]
          }
        },
        "geometry": {
          "type": "Point",
          "coordinates": [
            101.0945067,
            4.5985263
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "category": "cgc",
          "hours": "10am - 6pm",
          "description": "Lot No. 305, (Unit No.3486H) Ground Floor, Jalan Sultan Ibrahim 15050 Kota Bharu, Kelantan",
          "name": "CGC Kota Bharu",
          "phone": "+6097437730",
          "fax": "+6097437752",
          "ptc": "Norazlan bin Husain",
          "email": "norazlan.husain@cgc.com.my",
          "storeid": "03",
          "state": "Kelantan",
          "city": "Kota Bharu",
          "geometry": {
            "type": "Point",
            "coordinates": [
              102.2401767,
              6.1204399
            ]
          }
        },
        "geometry": {
          "type": "Point",
          "coordinates": [
            102.2401767,
            6.1204399
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "category": "cgc",
          "hours": "10am - 6pm",
          "description": "Lot PT 4018, Tingkat Bawah & Tingkat Satu Blok C, Perkedaian Ladang Tok Pelam Jalan Sultan Zainal, Kampung Ladang Tok Pelam, 20000 Kuala Terengganu, Terengganu",
          "name": "CGC Terengganu",
          "phone": "+6096252400",
          "fax": "+6096252399",
          "ptc": "Rosli Yahya",
          "email": "rosliyahya@cgc.com.my",
          "storeid": "04",
          "state": "Terengganu",
          "city": "Kuala Terengganu",
          "geometry": {
            "type": "Point",
            "coordinates": [
              103.1492608,
              5.3309278
            ]
          }
        },
        "geometry": {
          "type": "Point",
          "coordinates": [
            103.1492608,
            5.3309278
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "category": "cgc",
          "hours": "10am - 6pm",
          "description": "No. 113A, Ground & 1st Floor, Sri Dagangan Kuantan, Jalan Tun Ismail, 25000 Kuantan, Pahang",
          "name": "CGC Pahang",
          "phone": "+6095139277",
          "fax": "+6095139577",
          "ptc": "Rosmi Rizal Bin Mamat @ Ismail",
          "email": "rosmirizal@cgc.com.my",
          "storeid": "05",
          "state": "Pahang",
          "city": "Kuantan",
          "geometry": {
            "type": "Point",
            "coordinates": [
              103.3276374,
              3.8132569
            ]
          }
        },
        "geometry": {
          "type": "Point",
          "coordinates": [
            103.3276374,
            3.8132569
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "category": "cgc",
          "hours": "10am - 6pm",
          "description": "Level 1, Bangunan CGC, Kelana Business Centre, 97 Jalan SS7/2, 47301 Petaling Jaya Selangor",
          "name": "CGC Selangor",
          "phone": "+60378048100",
          "fax": "+60378061290",
          "ptc": "Azizi Bin Ahmad",
          "email": "aazizi@cgc.com.my",
          "storeid": "06",
          "state": "Selangor",
          "city": "Petaling Jaya (HQ)",
          "geometry": {
            "type": "Point",
            "coordinates": [
              101.5917856,
              3.0954953
            ]
          }
        },
        "geometry": {
          "type": "Point",
          "coordinates": [
            101.5917856,
            3.0954953
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "category": "cgc",
          "hours": "10am - 6pm",
          "description": "No. 194, Jalan Merdeka, Taman Melaka Raya, 75000 Melaka",
          "name": "CAWANGAN MELAKA",
          "phone": "+6062844300",
          "fax": "+6062832205",
          "ptc": "Nik Mohammad Hardian",
          "email": "hardian.ahmad@cgc.com.my",
          "storeid": "07",
          "state": "Melaka",
          "city": "Melaka",
          "geometry": {
            "type": "Point",
            "coordinates": [
              102.2554951,
              2.1878218
            ]
          }
        },
        "geometry": {
          "type": "Point",
          "coordinates": [
            102.2554951,
            2.1878218
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "category": "cgc",
          "hours": "10am - 6pm",
          "description": "No 34 A-0-1, KLSC, Jalan Wangsa Delima 6, Pusat Bandar Wangsa Maju KLSC, 53300 Kuala Lumpur",
          "name": "CGC Kuala Lumpur",
          "phone": "+60341496476",
          "fax": "+60341491237",
          "ptc": "Mohd Haniza Mohd Jaapar",
          "email": "mdhaniza@cgc.com.my",
          "storeid": "08",
          "state": "Kuala Lumpur",
          "city": "Wangsa Maju",
          "geometry": {
            "type": "Point",
            "coordinates": [
              101.7458613,
              3.1985309
            ]
          }
        },
        "geometry": {
          "type": "Point",
          "coordinates": [
            101.7458613,
            3.1985309
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "category": "cgc",
          "hours": "10am - 6pm",
          "description": "No. 9, Jalan S2 B15, Pusat Dagangan Seremban 2, 70300 Seremban, Negeri Sembilan",
          "name": "CGC HQ",
          "phone": "+6066017600",
          "fax": "+6066017001",
          "ptc": "Nor Ashikin Mohamed",
          "email": "norashikin.mohamed@cgc.com.my",
          "storeid": "09",
          "state": "Negeri Sembilan",
          "city": "Seremban",
          "geometry": {
            "type": "Point",
            "coordinates": [
              101.9055062,
              2.6939015
            ]
          }
        },
        "geometry": {
          "type": "Point",
          "coordinates": [
            101.9055062,
            2.6939015
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "category": "cgc",
          "hours": "10am - 6pm",
          "description": "No 46, Jalan Sulam, Taman Sentosa, 80150 Johor Bahru, Johor",
          "name": "CGC Johor Bahru",
          "phone": "+6073382788",
          "fax": "+6073344977",
          "ptc": "Don Teriady Abd Jalil",
          "email": "donteriady.abdjalil@cgc.com.my",
          "storeid": "10",
          "state": "Johor",
          "city": "Johor Bahru",
          "geometry": {
            "type": "Point",
            "coordinates": [
              103.766897,
              1.493323
            ]
          }
        },
        "geometry": {
          "type": "Point",
          "coordinates": [
            103.766897,
            1.493323
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "category": "cgc",
          "hours": "10am - 6pm",
          "description": "20, Jalan Maju, Taman Maju, Bukit Pasir 83000 Batu Pahat, Johor",
          "name": "CGC Batu Pahat",
          "phone": "+6074322633",
          "fax": "+6074323088",
          "ptc": "Mohd Zikhuan Mohd Miyan",
          "email": "mohdzikhuan.mm@cgc.com.my",
          "storeid": "11",
          "state": "Johor",
          "city": "Batu Pahat",
          "geometry": {
            "type": "Point",
            "coordinates": [
              102.9418497,
              1.8684004
            ]
          }
        },
        "geometry": {
          "type": "Point",
          "coordinates": [
            102.9418497,
            1.8684004
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "category": "cgc",
          "hours": "10am - 6pm",
          "description": "Lot 521, Sublot 12, Seksyen 6, KTLD, Jalan Kulas, 93400 Kuching, Sarawak",
          "name": "CGC Kuching",
          "phone": "+6082424200",
          "fax": "+6082427300",
          "ptc": "Alex Chin Shea Chien",
          "email": "scchin@cgc.com.my",
          "storeid": "12",
          "state": "Sarawak",
          "city": "Kuching",
          "geometry": {
            "type": "Point",
            "coordinates": [
              110.324171,
              1.5569843
            ]
          }
        },
        "geometry": {
          "type": "Point",
          "coordinates": [
            110.324171,
            1.5569843
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "category": "cgc",
          "hours": "10am - 6pm",
          "description": "Ground Floor, Lot 3551, Al-Bayt Square, Jalan Miri - Pujut, 98000 Miri, Sarawak",
          "name": "CGC Miri",
          "phone": "+6085421270",
          "fax": "+6085410370",
          "ptc": "Alex Chin Shea Chien",
          "email": "scchin@cgc.com.my",
          "storeid": "13",
          "state": "Sarawak",
          "city": "Miri",
          "geometry": {
            "type": "Point",
            "coordinates": [
              114.0108057,
              4.4132269
            ]
          }
        },
        "geometry": {
          "type": "Point",
          "coordinates": [
            114.0108057,
            4.4132269
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "category": "cgc",
          "hours": "10am - 6pm",
          "description": "D-21-G & D-21-1, Lot 21 Block D, KK Times Square, Signature Office, Off Costal Highway, 88100 KK, Sabah",
          "name": "CGC Sabah",
          "phone": "+6088486850",
          "fax": "+6088486851",
          "ptc": "Adolf Anthony Lajinga",
          "email": "adolfanthony@cgc.com.my",
          "storeid": "14",
          "state": "Sabah",
          "city": "Kota Kinabalu",
          "geometry": {
            "type": "Point",
            "coordinates": [
              116.0651073,
              5.9692168
            ]
          }
        },
        "geometry": {
          "type": "Point",
          "coordinates": [
            116.0651073,
            5.9692168
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "category": "cgc",
          "hours": "10am - 6pm",
          "description": "Lot 8 Blok 1, Jalan Labuk, Bandar Indah, Mile 4, 90000 Sandakan, Sabah",
          "name": "CGC Sabah",
          "phone": "+6089224698",
          "fax": "+6089224963",
          "ptc": "Adolf Anthony Lajinga",
          "email": "adolfanthony@cgc.com.my",
          "storeid": "15",
          "state": "Sabah",
          "city": "Sandakan",
          "geometry": {
            "type": "Point",
            "coordinates": [
              118.0752961,
              5.8545636
            ]
          }
        },
        "geometry": {
          "type": "Point",
          "coordinates": [
            118.0752961,
            5.8545636
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "category": "cgc",
          "hours": "10am - 6pm",
          "description": "No. 17, Ground Floor, Jalan Todak 6, Sunway Perdana, 13700 Seberang Jaya, Pulau Pinang",
          "name": "CGC Penang",
          "phone": "+60043992400",
          "fax": "+60043975434",
          "ptc": "Nori Harni Juhari",
          "email": "jnoriharni@cgc.com.my",
          "storeid": "16",
          "state": "Pulau Pinang",
          "city": "Seberang Jaya",
          "geometry": {
            "type": "Point",
            "coordinates": [
              100.39815746647054,
              5.396263920355965
            ]
          }
        },
        "geometry": {
          "type": "Point",
          "coordinates": [
            100.39815746647054,
            5.396263920355965
          ]
        }
      }
    ]
  }